// @flow

import * as Actions from 'actionTypes';

type Action = {
  type: string,
  viewport: string,
  isXs: boolean
};

/**
 * It runs the correct action received
 * @param {object} state of the application
 * @param {object} action received
 * @return {object} new object which represent the new state after the action
 */
const currentViewport = (
  state: Object = {
    viewport: 'xs',
    isXs: false
  },
  action: Action
): Object => {
  return action.type === Actions.GET_VIEWPORT
    ? { ...state, viewport: action.viewport, isXs: action.isXs }
    : state;
};

export default currentViewport;



// WEBPACK FOOTER //
// ./src/reducers/viewport.reducer/index.js